export const SUPER_ADMIN_SET_COMPANIES = 'SUPER_ADMIN_SET_COMPANIES';
export const SUPER_ADMIN_SET_NEW_DATE_FOR_COMPANY = 'SUPER_ADMIN_SET_NEW_DATE_FOR_COMPANY';
export const SUPER_ADMIN_REMOVE_USER_TO_BRAND = 'SUPER_ADMIN_REMOVE_USER_TO_BRAND';
export const SUPER_ADMIN_ADD_USER_TO_BRAND = 'SUPER_ADMIN_ADD_USER_TO_BRAND';
export const SUPER_ADMIN_SET_NEW_COMPANY_ADMIN = 'SUPER_ADMIN_SET_NEW_COMPANY_ADMIN';
